"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIDUploadLink = exports.GET_LINK = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _ajax = require("./ajax");

var _httpActions = require("./http-actions");

var GET_LINK = 'GET_LINK';
exports.GET_LINK = GET_LINK;
var CONTEXT = '/service-id-upload/secure';
/**
 * Returns link to send user to /id-upload mobile capture flow
 * @param {Object} data
 *   - {String} applicationUuid
 *   - {String} identityUuid
 *   - {String} firstName
 *   - {String} lastName
 *   - {String} productType
 */

var getIDUploadLink = function getIDUploadLink(data) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(dispatch) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", (0, _ajax.ajaxPost)(GET_LINK, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/link/create"), data));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.getIDUploadLink = getIDUploadLink;